<ng-container *ngIf="loading">
  <div class="loading-bar">
      <tm1-progress-ring value="" min="0" max="1" size="regular" ></tm1-progress-ring>
</div>
</ng-container>

<ng-container *ngIf="isModalOpen">
  <div class="modal">
    <tm1-card class="modal-content">
      <span class="close" (click)="closeModal()">&times;</span>
      <tm1-typography type="data-l">Are you sure?</tm1-typography>
      <br/>
      <tm1-typography type="data-s">Turning off the pre-check flag will cause the test scans to count towards the events overall attendance</tm1-typography>
      <br/>
      <tm1-button variant="solid" (click)="keepValidation()">Keep Validation</tm1-button>
      <tm1-button variant="solid" (click)="closeModal()">Continue</tm1-button>
    </tm1-card>
  </div>
  </ng-container>

<div class="topborderButton">
    <tm1-button routerLink="/tools/barcodehistory"> Barcode History </tm1-button>
    <tm1-button *ngIf="isTicketmaster" routerLink="/tools/gates">Gate Set Up</tm1-button>
    <tm1-button routerLink="/tools/scanner">Scanner</tm1-button>
</div>
<div class = "container">
<div class="card-container">
    <tm1-card>
          <legend>Scanner</legend>
          <span>
            <tm1-label>Venue</tm1-label>
            <select  class="form-control" [(ngModel)]="Selectedvenue" (change) = "onVenueChange(); getGates($event);">
                <option value="">Please Select a Venue</option>
                <option *ngFor="let venue of venuelist" [value]="venue.key">
                  {{ venue.value.name }}
                </option>
              </select>
          </span>
          <br />

          <span>
            <tm1-label>Gate
              <tm1-icon-tooltip *ngIf="!isTicketmaster" icon="info" size="small" color="blue">
                Please contact your TM rep to add/change gates
              </tm1-icon-tooltip>
            </tm1-label>
            <tm1-select ngDefaultControl size="100" inputSize="Large" style="width: auto"
              (change)="onGateChange($event)">
              <tm1-option>Select A Gate</tm1-option>
              <ng-container *ngFor="let gates of gatesArray">
                <tm1-option value="{{ gates.value }}">{{
                  gates.value
                  }}</tm1-option></ng-container>
            </tm1-select>


          </span>
          <span>
            <tm1-text-area appearance="outline" cols="20" label="Barcodes"
              supportingtext="Ensure each Barcode is on a new line when testing multiple" name="Barcodes"
              (change)="onBarcodeChange($event)" placeholder="" resize="vertical" rows="" spellcheck=""
              value="" error="">
            </tm1-text-area>

          </span>
          <br />

          <span>
            <tm1-checkbox
                (change)="selectPreCheckChangeHandler($event)"
                size="small"
                label="venueAdmin"
                [checked]="togglePrecheckCheckBox()"
                [disabled]="!isTicketmaster"
                >Validation Only
                <tm1-icon-tooltip icon="info" size="small" color="blue">
                  This option validates the barcode against active events and gate rules. Attendance will not be recorded for this scan
                </tm1-icon-tooltip>
              </tm1-checkbox>
          </span>

          <br/>

          <span>
            <tm1-label>Direction</tm1-label>
            <tm1-select size="100" inputSize="Large" style="width: auto"
              (change)="onDirectionChange($event)">
              <tm1-option value="#">Select a Direction</tm1-option>
              <tm1-option value="Enter">Enter</tm1-option>
              <tm1-option value="Exit">Exit</tm1-option>
              <tm1-option value="Both">Both</tm1-option>
            </tm1-select>

          </span>
          <br />
          <tm1-button variant="solid" style="width: max-content" (click)="sendScan()">
            Scan
          </tm1-button>
    </tm1-card>
  
</div>

<div class="table-containerScanner">
  <ng-container *ngIf="loading">
    <tm1-data-grid class="tm1-data-grid" generate-header="" focus-column-index="0" focus-row-index="0">
      <tm1-data-grid-row class="tm1-data-grid-row" row-type="sticky-header">
        <tm1-data-grid-cell grid-column="1" cell-type="columnheader">Scanner</tm1-data-grid-cell>
      </tm1-data-grid-row>
      <tm1-data-grid-cell grid-column="1">
        Scanning......
      </tm1-data-grid-cell>
    </tm1-data-grid>
  </ng-container>

<ng-container class="table-container" *ngIf = "scanResult.length !== 0">
  <tm1-button class="copy-button" (click) = "copyTableToClipboard()">Copy Table</tm1-button>
    <tm1-data-grid #dataGrid generate-header="" focus-column-index="0"
      focus-row-index="0">
      <tm1-data-grid-row row-type="sticky-header">
        <tm1-data-grid-cell grid-column="1" cell-type="columnheader">Barcode</tm1-data-grid-cell>
        <tm1-data-grid-cell grid-column="2" cell-type="columnheader">Gate</tm1-data-grid-cell>
        <tm1-data-grid-cell grid-column="3" cell-type="columnheader">Direction</tm1-data-grid-cell>
        <tm1-data-grid-cell grid-column="4" cell-type="columnheader">Result</tm1-data-grid-cell>
        <tm1-data-grid-cell grid-column="5" cell-type="columnheader">Event ID</tm1-data-grid-cell>
        <tm1-data-grid-cell grid-column="6" cell-type="columnheader">Place</tm1-data-grid-cell>
        <tm1-data-grid-cell grid-column="7" cell-type="columnheader">Message</tm1-data-grid-cell>
        <tm1-data-grid-cell grid-column="8" cell-type="columnheader">Scan Time</tm1-data-grid-cell>
      </tm1-data-grid-row>



      <ng-container *ngFor="let data of scanResult">
      <tm1-data-grid-row>
          <tm1-data-grid-cell grid-column="1">
            {{data.Barcode}}
          </tm1-data-grid-cell>
          <tm1-data-grid-cell grid-column="2">
            {{data.Gate.name}}
          </tm1-data-grid-cell>
          <tm1-data-grid-cell grid-column="3">
            {{data.Direction}}
          </tm1-data-grid-cell>
          <tm1-data-grid-cell grid-column="4">
            {{data.Result}}
          </tm1-data-grid-cell>
          <ng-container *ngIf="data.MessageExt !== ''">
            <tm1-data-grid-cell grid-column="5">
                {{data.MessageExt?.[0]?.eventId}}
            </tm1-data-grid-cell>
            <tm1-data-grid-cell grid-column="6">
            {{data.MessageExt?.[0]?.place}}
            </tm1-data-grid-cell>
            <tm1-data-grid-cell grid-column="7">
            {{data.MessageExt?.[0]?.messages[0] ?? 'No Message'}}
            </tm1-data-grid-cell>
            </ng-container>
          <tm1-data-grid-cell grid-column="8">
            {{data.ScanTime}}
          </tm1-data-grid-cell>
      </tm1-data-grid-row>
    </ng-container>
    </tm1-data-grid>
    </ng-container>
</div>

  </div>